import { apiWrapper } from "@/services/api";

/**
 * GET master_surveys/{id} を呼び出しアンケートマスターデータを返す
 * @param {number} id - master_survey_id
 * @returns {Promise<Object>} APIレスポンスのdataフィールド
 */
export const getMasterSurvey = async (id) => {
  const resp = await apiWrapper("GET", `master_surveys/${id}`);
  return resp.data;
};
